(function () {
  'use strict';
  const pdp = document.querySelector('[data-bae-pdp]');
  if (!pdp) return;

  const variants = JSON.parse(pdp.querySelector('[data-bae-variants]').textContent || '[]');
  const cfgEl = pdp.querySelector('[data-bae-pdp-config]');
  const config = cfgEl ? JSON.parse(cfgEl.textContent) : { lowStock: 5 };
  const EN = (config.lang || 'nl') === 'en';
  const idInput = pdp.querySelector('[data-bae-variant-id]');
  const atc = pdp.querySelector('[data-bae-atc]');
  const priceEl = pdp.querySelector('[data-bae-price]');
  const stockEl = pdp.querySelector('[data-bae-stock]');
  const finalRunEl = pdp.querySelector('[data-bae-finalrun]');
  const money = (c) => (c / 100).toLocaleString('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });

  /* Brand colours for the colour swatches (same map as snippets/baesole-swatch-style).
     Applied here so Vintage Black, Vanilla Cream, Beige etc. never fall back to grey. */
  const SWATCH_COLOURS = {
    'white': '#F6F2E9', 'black': '#1A1A1A', 'vintage black': '#33322E', 'vintage white': '#E9E4D6',
    'dark green': '#2C3A2E', 'donkergroen': '#2C3A2E', 'green': '#2C3A2E',
    'creme': '#ECE4D2', 'crème': '#ECE4D2', 'cream': '#ECE4D2', 'vanilla cream': '#EAE3CF', 'vanille': '#EAE3CF',
    'sand': '#CDBFA3', 'zand': '#CDBFA3', 'beige': '#D8CBB0', 'tan': '#B79B76', 'cognac': '#8A5A3B',
    'terracotta': '#A85E42', 'navy': '#22303F', 'grey': '#9A9A93', 'gray': '#9A9A93', 'grijs': '#9A9A93',
    'stone grey': '#A8A69F', 'stone gray': '#A8A69F'
  };
  pdp.querySelectorAll('.bae-swatch[data-value]').forEach((b) => {
    const c = SWATCH_COLOURS[String(b.dataset.value || '').toLowerCase().trim()];
    if (c) b.style.background = c;
  });

  const selected = [];
  pdp.querySelectorAll('[data-bae-option-index]').forEach((wrap) => {
    const i = Number(wrap.dataset.baeOptionIndex);
    const active = wrap.querySelector('[data-bae-optbtn].is-active');
    selected[i] = active ? active.dataset.value : null;
  });

  const findVariant = () => variants.find((v) => selected.every((val, i) => val === null || v.options[i] === val));

  function optionAvailable(index, value) {
    const probe = selected.slice();
    probe[index] = value;
    return variants.some((v) => probe.every((val, i) => val === null || v.options[i] === val) && v.available);
  }

  /* A non-size option value (e.g. Fit) only exists when a variant has it
     together with the options chosen before it (e.g. Color). Values that
     do not exist for the chosen colour are hidden, so Stone Grey never
     shows an Oversized choice. */
  function optionExists(index, value) {
    if (index === 0 || index === config.sizeIndex) return true;
    return variants.some((v) => v.options[index] === value
      && selected.every((val, j) => j >= index || val === null || v.options[j] === val));
  }

  /* After the option at index i changed: when the later options no longer
     form an existing variant, move them to the closest existing variant
     (keeps size and availability where possible). */
  function reconcile(i) {
    const cands = variants.filter((v) => selected.every((val, j) => j > i || val === null || v.options[j] === val));
    if (!cands.length) return;
    const score = (v) => selected.reduce((s, val, j) => s + (j > i && val !== null && v.options[j] === val ? 1 : 0), 0) * 10 + (v.available ? 1 : 0);
    const best = cands.reduce((a, b) => (score(b) > score(a) ? b : a));
    selected.forEach((val, j) => {
      if (j > i && best.options[j] !== val) {
        selected[j] = best.options[j];
        const wrap = pdp.querySelector('[data-bae-option-index="' + j + '"]');
        if (wrap) wrap.querySelectorAll('[data-bae-optbtn]').forEach((b) => b.classList.toggle('is-active', b.dataset.value === best.options[j]));
      }
    });
  }

  /* Compare images by file name: the variant JSON and the rendered slides can
     use different CDN hosts/paths for the same file, so full URLs never match. */
  const fileName = (u) => String(u || '').split('?')[0].split('/').pop().toLowerCase();

  function refresh() {
    pdp.querySelectorAll('[data-bae-option-index]').forEach((wrap) => {
      const i = Number(wrap.dataset.baeOptionIndex);
      wrap.querySelectorAll('[data-bae-optbtn]').forEach((btn) => {
        const avail = optionAvailable(i, btn.dataset.value);
        if (btn.classList.contains('bae-qa__size')) btn.disabled = !avail;
        else btn.style.opacity = avail ? '' : '.35';
        btn.style.display = optionExists(i, btn.dataset.value) ? '' : 'none';
      });
      const label = pdp.querySelector('[data-bae-optval="' + i + '"]');
      if (label && selected[i]) label.textContent = selected[i];
    });

    const v = findVariant();
    if (!v) {
      atc.disabled = true;
      atc.textContent = EN ? 'Unavailable' : 'Niet beschikbaar';
      if (stockEl) stockEl.textContent = '';
      if (finalRunEl) finalRunEl.hidden = true;
      return;
    }

    idInput.value = v.id;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);

    priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
      ? '<span class="bae-card__price-now">' + money(v.price) + '</span><s class="bae-card__price-was">' + money(v.compare_at_price) + '</s>'
      : '<span>' + money(v.price) + '</span>';

    const ptsEl = pdp.querySelector('[data-bae-points]');
    if (ptsEl) ptsEl.textContent = Math.round(v.price / 100 * 10);

    atc.disabled = !v.available;
    /* Primary CTA is Dutch storefront copy in every locale. */
    atc.textContent = v.available ? 'In winkelwagen' : (EN ? 'Sold out' : 'Uitverkocht');

    /* Real inventory only. Restrained wording, names the selected size,
       updates per variant. Sold-out variants show no urgency copy at all. */
    if (finalRunEl) finalRunEl.hidden = !v.available;
    if (stockEl) {
      const q = v.inventory_quantity;
      const size = config.sizeIndex >= 0 && v.options ? v.options[config.sizeIndex] : '';
      const inSize = size ? (EN ? ' in size ' + size : ' in maat ' + size) : (EN ? ' in this size' : ' in deze maat');
      if (v.available && v.inventory_management && typeof q === 'number' && q > 0 && q <= config.lowStock) {
        stockEl.textContent = q === 1
          ? (EN ? 'Last one' + inSize + '.' : 'Laatste stuk' + inSize + '.')
          : (EN ? 'Only a few left' + inSize + '.' : 'Nog enkele beschikbaar' + inSize + '.');
      } else {
        stockEl.textContent = '';
      }
    }

    /* Jump the gallery to the variant's own image (colour change). */
    const want = v.featured_image && v.featured_image.src ? fileName(v.featured_image.src) : '';
    if (want) {
      const imgs = Array.from(pdp.querySelectorAll('.bae-pdp__slide img'));
      let idx = imgs.findIndex((img) => fileName(img.getAttribute('src')) === want);
      if (idx < 0) idx = imgs.findIndex((img) => fileName(img.currentSrc) === want);
      if (idx > -1) goTo(idx);
    }
  }

  pdp.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bae-optbtn]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const i = Number(btn.dataset.index);
    const wrap = btn.closest('[data-bae-option-index]');
    wrap.querySelectorAll('[data-bae-optbtn]').forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    selected[i] = btn.dataset.value;
    reconcile(i);
    if (config.sizeIndex >= 0 && selected[config.sizeIndex]) {
      try { sessionStorage.setItem('bae:size', selected[config.sizeIndex]); } catch (err) {}
    }
    refresh();
  });

  /* Preserve the chosen size when switching between colour products —
     only applied when that size exists AND leads to an available variant. */
  try {
    const savedSize = sessionStorage.getItem('bae:size');
    if (savedSize && config.sizeIndex >= 0 && selected[config.sizeIndex] !== savedSize
      && optionAvailable(config.sizeIndex, savedSize)) {
      const btn = Array.from(pdp.querySelectorAll('.bae-pdp__sizes [data-bae-optbtn]'))
        .find((b) => b.dataset.value === savedSize);
      if (btn) {
        const wrap = btn.closest('[data-bae-option-index]');
        wrap.querySelectorAll('[data-bae-optbtn]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selected[config.sizeIndex] = savedSize;
      }
    }
  } catch (err) {}

  /* =========================================================
     Gallery — ONE source of truth: the track's scroll position.
     Every control (thumbnail, arrow, bar click/drag, swipe,
     variant image jump) moves the track; sync() derives the
     active index from the track and updates main image state,
     active thumbnail, progress bar and arrow state together.
     ========================================================= */
  const track = pdp.querySelector('[data-bae-pdp-track]');
  const bar = pdp.querySelector('[data-bae-pdp-bar]');
  const thumb = pdp.querySelector('[data-bae-pdp-thumb]');
  const thumbBtns = pdp.querySelectorAll('[data-bae-pdp-thumbbtn]');
  const prevBtn = pdp.querySelector('[data-bae-pdp-prev]');
  const nextBtn = pdp.querySelector('[data-bae-pdp-next]');
  const count = track ? track.children.length : 0;

  const currentIndex = () => (track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0);
  function goTo(i) {
    if (!track) return;
    const clamped = Math.max(0, Math.min(count - 1, i));
    track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
  }

  if (track) {
    const sync = () => {
      const i = currentIndex();
      if (thumb) { thumb.style.width = (100 / count) + '%'; thumb.style.left = (i * 100 / count) + '%'; }
      thumbBtns.forEach((b, n) => b.classList.toggle('is-active', n === i));
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= count - 1;
    };
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    thumbBtns.forEach((b) => b.addEventListener('click', () => goTo(Number(b.dataset.baePdpThumbbtn))));
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));

    /* Progress bar: click + drag scrub, keyboard arrows. */
    if (bar) {
      let dragging = false;
      const setFromX = (clientX) => {
        const r = bar.getBoundingClientRect();
        const p = Math.max(0, Math.min(1, (clientX - r.left) / r.width));
        const max = track.scrollWidth - track.clientWidth;
        track.scrollLeft = p * max;
      };
      bar.addEventListener('pointerdown', (e) => {
        dragging = true;
        bar.setPointerCapture(e.pointerId);
        track.style.scrollSnapType = 'none';
        setFromX(e.clientX);
      });
      bar.addEventListener('pointermove', (e) => { if (dragging) setFromX(e.clientX); });
      const endDrag = () => {
        if (!dragging) return;
        dragging = false;
        track.style.scrollSnapType = '';
        goTo(currentIndex());
      };
      bar.addEventListener('pointerup', endDrag);
      bar.addEventListener('pointercancel', endDrag);
      bar.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { goTo(currentIndex() + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { goTo(currentIndex() - 1); e.preventDefault(); }
      });
    }
  }

  /* add to cart */
  const form = pdp.querySelector('#bae-product-form') || pdp.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      atc.disabled = true;
      const original = atc.textContent;
      atc.textContent = 'Toevoegen…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then((r) => r.json()).then(() => fetch('/cart.js')).then((r) => r.json())
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('bae:cart:updated', { detail: cart }));
          atc.textContent = 'Toegevoegd';
          setTimeout(() => { atc.textContent = original; atc.disabled = false; }, 1300);
        })
        .catch(() => { atc.textContent = original; atc.disabled = false; });
    });
  }

  refresh();
})();
